import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Dettagli aggiornati',
  previous_details: 'Dettagli precedenti',
  fields: {
    datetime: 'Data:',
    email: 'Email:',
    phone_number: 'Numero di telefono:',
    customer: 'Cliente:',
    source: 'Fonte:',
    guests: 'Ospiti:',
    comment: 'Commento:',
    confirmed_at: 'Confermato il:',
    status: 'Stato:',
    occasion: 'Occasione:',
    created_at: 'Creato il:',
  },
  status: {
    confirmed: 'Confermato',
    pending: 'In attesa di approvazione',
    canceled: 'Annullato',
    canceled_by_customer: 'Annullato dal cliente',
    rejected: 'Rifiutato',
    removed: 'Rimosso',
  },
  buttons: {
    confirm: 'Conferma',
    reject: 'Rifiuta',
    cancel: 'Annulla',
    edit: 'Modifica',
    remove: 'Rimuovi',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Compleanno',
    [ReservationOccasion.Anniversary]: 'Anniversario',
    [ReservationOccasion.Date]: 'Data',
    [ReservationOccasion.SpecialOccasion]: 'Occasione speciale',
    [ReservationOccasion.BusinessMeal]: 'Pasto di lavoro',
  },
  remove_reservation_modal: {
    title: 'Sei sicuro di voler rimuovere la prenotazione?',
    buttons: {
      remove: 'Rimuovi',
      cancel: 'Annulla',
    },
  },
  response_messages: {
    success: 'Stato prenotazione aggiornato. Il cliente è stato notificato.',
    error: 'Aggiornamento dello stato della prenotazione fallito. Riprova.',
  },
};
